/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserVerificationResponse {
    getFixupPrototypeFunction() { return UserVerificationResponse.fixupPrototype; }

    static newInstance(model: Partial<UserVerificationResponse>): UserVerificationResponse {
        let obj = Object.assign(new UserVerificationResponse(), model);
        UserVerificationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserVerificationResponse>): UserVerificationResponse {
        if (!model) return null;
        return UserVerificationResponse.newInstance(<UserVerificationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserVerificationResponse) {
        if (!obj) return;

        models.UserVerificationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserVerificationResponse): boolean {
        Object.setPrototypeOf(obj, UserVerificationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User id
     */
    user_id: string;

    token: string;

    reset_key: string;

    status: string;

}
